<template>
  <div v-if="querying === false" class="container">
    <span class="stats">
      <span style="font-weight: bold; margin-right:4px;">results</span>
      {{ Math.min(count, page * rpp + 1) }}-{{
        Math.min(count, (page + 1) * rpp)
      }}
      of {{ count }} in
      {{ stats.executionTime.toString().substring(0, 6) }} seconds
    </span>
    <span class="pages" v-if="num > 1">
      <button v-if="page > 0" @click="nav(-1)">
        <md-icon>
          navigate_before
        </md-icon>
      </button>
      <span
        v-for="(p, i) in pages"
        :key="i"
        @click="navPage(p)"
        style="margin-left:5px; margin-right:5px;"
        v-bind:class="{ active: p === page }"
      >
        {{ p + 1 }}
      </span>
      <button v-if="page < num - 1" @click="nav(1)">
        <md-icon>
          navigate_next
        </md-icon>
      </button>
    </span>
    <span class="rpp">
      <span style="float:right;">
        res/page:
      </span>
      <br />
      <select v-model="rpp" style="float:right">
        <option v-for="v in [1, 5, 10, 20]" :key="v" :value="v">{{ v }}</option>
      </select>
    </span>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      page: state => state.search.page,
      count: state => state.search.stats.fullCount,
      querying: state => state.search.querying,
      stats: state => state.search.stats,
    }),

    rpp: {
      get() {
        return this.$store.state.search.rpp
      },
      set(val) {
        this.$store.state.search.rpp = val
      },
    },

    num() {
      return Math.ceil(this.count / this.rpp)
    },

    pages() {
      if (this.num <= 5) {
        return [...Array(this.num).keys()]
      }
      const two = Math.ceil(this.page / 2)
      const four = Math.ceil((this.num - this.page) / 2) + this.page
      let arr = [0]
      if (two) {
        arr.push(two)
      }
      if (this.page > 1) {
        arr.push(this.page)
      }
      if (four > this.page && four < this.num) {
        arr.push(four)
      }
      if (!arr.includes(this.num - 1)) {
        arr.push(this.num - 1)
      }
      return arr
    },
  },

  methods: {
    ...mapActions({
      search: 'search/submit',
    }),

    nav(dir) {
      this.$store.state.search.page += dir
    },

    navPage(p) {
      this.$store.state.search.page = p
    },
  },

  watch: {
    page() {
      this.search(true)
    },
    rpp() {
      this.search(true)
    },
  },
}
</script>

<style scoped>
.container {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
}
.stats {
  display: inline-flex;
  min-height: 24px;
  margin: 5px;
  font-size: 16px;
}
.pages {
  display: inline-flex;
  align-items: center;
  font-weight: normal;
  cursor: pointer;
  padding: 2px;
}
.active {
  font-weight: bolder;
  border: solid 1px black;
  padding: 2px;
}
.rpp {
  align-items: center;
  padding: 2px;
}
</style>
